import { render, staticRenderFns } from "./TagValueAttribute.vue?vue&type=template&id=1e0a265f&scoped=true"
import script from "./TagValueAttribute.vue?vue&type=script&lang=js"
export * from "./TagValueAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0a265f",
  null
  
)

export default component.exports